import {IPreferencesBusiness, IUserState} from "../../interfaces";
import {initialUndoRedoState} from "ngrx-wieder";

export const initialUserState: IUserState = {
    createCredentials: null,
    dynawebs: {
        cart: null,
        order: null,
        products: null,
        dynawebsServer: null
    },
    userDetails: null,
    selectedUser: null,
    cart: {
        products: null,
        cartContent: null,
        cartVersion: null,
        total: null,
        subTotal: null,
        delivery: null,
        tax: null,
        cartLocation: null
    },
    orders: null,
    order: null,
    painters: [],
    changelistId: null,
    lastGetTime: null,
    globalSettings: [],
    preferences: null,
    twoFactorState: null,
    scenes: [],
    trash: [],
    resources: [],
    trashResources: [],
    resourceSharedLibrary: null,
    catalogItemInfos: [],
    catalogItemResources: [],
    catalogItemCategories: [],
    catalogItems: [],
    categoryValues: [],
    schedules: [],
    scheduleEvents: [],
    transitionPools: [],
    transitionPoolItems: [],
    musicChannels: [],
    musicChannelSongs: [],
    eventParams: [],
    eventsStrings: [],
    eventBlocks: [],
    iots: [],
    stations: null,
    liveStations: null,
    stationStats: [],
    userStationGeoIPs: [],
    preLoginResellerInfo: null,
    sceneTemplateImports: null,
    lockedRecord: null,
    crudScene: null,
    ...initialUndoRedoState,
};
